import React from 'react';
import { Trophy, UserCheck } from 'lucide-react';
import { IMAGES, CHECKOUT_URL, APP_URL } from '../mock';

export default function Hero() {
  return (
    <section className="gradient-bg-hero relative overflow-hidden pt-16 pb-32">
      <div className="max-w-7xl mx-auto px-6 pt-24 md:pt-16 grid md:grid-cols-2 gap-10 items-center">
        <div className="flex justify-center md:justify-end order-2 md:order-1">
          <img src={IMAGES.sween1} alt="Sween" className="max-w-[420px] w-full animate-float" />
        </div>
        <div className="order-1 md:order-2 text-center md:text-left">
          <h1 className="font-heading font-extrabold text-4xl md:text-5xl lg:text-6xl leading-tight text-[#1a0929]">
            Sua jornada até a<br />
            <span className="pink-highlight">MEDALHA DE OURO</span><br />
            começa AGORA!
          </h1>
          <p className="mt-8 text-base md:text-lg text-[#3a1450] leading-relaxed">
            A <span className="underline-purple">Academia de Pitágoras (ADP)</span> é a maneira mais otimizada possível para te fazer conquistar seu <span className="yellow-highlight font-semibold">OURO</span> em olimpíadas de nível <span className="underline-purple">OBMEP</span>!
          </p>
          <div className="mt-8 flex flex-col gap-3 max-w-md mx-auto md:mx-0">
            <a href={CHECKOUT_URL} target="_blank" rel="noreferrer" className="btn-magenta w-full">
              QUERO ME TORNAR UM MEDALISTA <Trophy size={20} />
            </a>
            <a href={APP_URL} target="_blank" rel="noreferrer" className="btn-outline w-full">
              JÁ SOU ALUNO <UserCheck size={18} />
            </a>
          </div>
        </div>
      </div>
      <div className="wave-divider-bottom">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
          <path d="M0,32 C240,72 480,72 720,48 C960,24 1200,24 1440,56 L1440,80 L0,80 Z" fill="#7a1fb0"></path>
        </svg>
      </div>
    </section>
  );
}
